'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'Week',
    render: function render() {
        return _react2.default.createElement(
            'tr',
            { className: 'Week' },
            this.props.children
        );
    }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-calendar-pane/lib/Week.js
// module id = 1035
// module chunks = 0